import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { StoreProvider } from './Store';
import { installSessionGuard } from './sessionGuard';
import { DeveloperAccessProvider } from './DeveloperAccess';
import { installScrollLockWatchdog } from './scrollLock';

// Must run before any component fires a request, so an idle sign-out is caught
// on the very first 401 rather than after the page has already failed to load.
installSessionGuard();

installScrollLockWatchdog();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <StoreProvider>
    {/* Inside StoreProvider: the developer unlock needs the signed-in admin's
        token to ask the server for a ticket. */}
    <DeveloperAccessProvider>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </DeveloperAccessProvider>
  </StoreProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
